import * as Updates from "expo-updates";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import RText from "./RText";
import { APP_ENV } from "../client";
import { getDeviceId } from "../utils/getDeviceId";

export const AppInfo = () => {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    getDeviceId().then((id) => setDeviceId(id));
  }, []);

  return (
    <View style={{ padding: 10 }}>
      <RText color="grey">
        Version: {APP_ENV}-{Updates.runtimeVersion}
      </RText>
      <RText color="grey">Update: {Updates.updateId}</RText>
      <RText color="grey">Patch time: {Updates.createdAt?.toUTCString()}</RText>
      <RText color="grey">{deviceId}</RText>
    </View>
  );
};
